var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      !_vm.loading
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "table",
                  {
                    staticClass: "table dataTable table-striped table-borders",
                    attrs: { id: "urlparams" }
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAllColumns,
                                expression: "showAllColumns"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Id")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: true,
                                expression: "true"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Action")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: true,
                                expression: "true"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Parameter")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: true,
                                expression: "true"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Question")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAllColumns,
                                expression: "showAllColumns"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Survey ID")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAllColumns,
                                expression: "showAllColumns"
                              }
                            ]
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Question ID")))]
                        ),
                        _c(
                          "th",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showAllColumns,
                                expression: "showAllColumns"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              _vm._s(_vm._f("translate")("Subquestion ID"))
                            )
                          ]
                        )
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.parameterRows, function(parameterRow) {
                        return _c(
                          "tr",
                          {
                            key: parameterRow.id,
                            attrs: {
                              "data-rowdata": JSON.stringify(parameterRow)
                            }
                          },
                          [
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAllColumns,
                                    expression: "showAllColumns"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(parameterRow.id))]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: true,
                                    expression: "true"
                                  }
                                ]
                              },
                              [
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-default",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.editRow(parameterRow)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-edit" })]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-danger",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.deleteRow(parameterRow)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                ])
                              ]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: true,
                                    expression: "true"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(parameterRow.parameter))]
                            ),
                            _c("td", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: true,
                                  expression: "true"
                                }
                              ],
                              domProps: {
                                innerHTML: _vm._s(
                                  parameterRow.targetQuestionText +
                                    (parameterRow.sqid != ""
                                      ? " => " +
                                        parameterRow.targetSubQuestionText
                                      : "")
                                )
                              }
                            }),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAllColumns,
                                    expression: "showAllColumns"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(parameterRow.sid))]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAllColumns,
                                    expression: "showAllColumns"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(parameterRow.qid))]
                            ),
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAllColumns,
                                    expression: "showAllColumns"
                                  }
                                ]
                              },
                              [_vm._v(_vm._s(parameterRow.sqid))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _c("input", {
                  attrs: {
                    type: "hidden",
                    id: "allurlparams",
                    name: "allurlparams"
                  },
                  domProps: { value: _vm.combinedValues }
                })
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addNewParam($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("translate")("Add parameter")))]
                )
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "modal fade",
                class: { in: _vm.modalShown },
                attrs: {
                  id: "lspanelintegration-parameterPopup",
                  role: "dialog"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", attrs: { role: "document" } },
                  [
                    _c("parameterpopup", {
                      attrs: { "is-new": _vm.isNew },
                      on: {
                        updateparam: _vm.paramUpdated,
                        canceledit: _vm.toggleModal
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: { id: "lspanelintegration-deletePopup", role: "dialog" }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog", attrs: { role: "document" } },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-body" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Are you sure you want to delete this URL parameter?"
                            )
                          )
                        )
                      ]),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.cancelDelete($event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Cancel")))]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.confirmDelete($event)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("translate")("Yes, delete")))]
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ]
        : _vm._e(),
      _vm.loading
        ? _c("loader-widget", { attrs: { id: "panelintegrationloader" } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }